module.exports = __webpack_public_path__ + "media/MRI17-ad.d2b118f4.mp3";